import { useMemo } from "react";
import ConciliacaoAuttarConsultaScreen from "./ConciliacaoAuttarConsultaScreen";
import { EnumTrabalhoTipo } from "@/Models/Sistema/Trabalho/TrabalhoTipo";

type ConciliacaoPagBankTipo = "VENDAS"|"PAGAMENTOS"|"CANCELAMENTO";
interface IConciliacaoPagBankScreenProps {
    tipo:ConciliacaoPagBankTipo;
}

function obterCodigoTrabalhoTipo(tipo:ConciliacaoPagBankTipo) {
  switch (tipo) {
    case 'VENDAS':
      return EnumTrabalhoTipo.PagBankConciliacao;
    case 'PAGAMENTOS':
      return EnumTrabalhoTipo.PagBankConciliacaoPagamentos;
    case 'CANCELAMENTO':
      return EnumTrabalhoTipo.PagBankConciliacaoCancelamentos;
  }
}

export default function ConciliacaoPagBankScreen({
    tipo
}:IConciliacaoPagBankScreenProps) {
    const codTrabalhoTipo = useMemo(() => obterCodigoTrabalhoTipo(tipo), [tipo]);
    return <ConciliacaoAuttarConsultaScreen 
        codTrabalhoTipo={codTrabalhoTipo} 
    />;
}